import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ON_SITE_ID, BY_PHONE_ID, IN_BRANCH_BY_ON_SITE, IN_BRANCH_BY_ONLINE_VIDEO, IN_BRANCH_PUBLIC_ID, IN_BRANCH_VIDEO_ID, IN_BRANCH_PRIVATE_VIDEO_ID, IN_BRANCH_BY_PHONE_PUBLIC_ID, IN_BRANCH_BY_PHONE_PRIVATE_ID, IN_BRANCH_BY_VIDEO_PUBLIC_ID, IN_BRANCH_BY_VIDEO_PRIVATE_ID, IN_SERVICE_POINT, IN_SERVICE_POINT_BY_PHONE, } from '@/helpers/appointment';
const AppointmentStore = namespace('AppointmentStore');
let AppointmentMixin = class AppointmentMixin extends Vue {
    appointmentType;
    get isOnPhoneFlow() {
        return this.appointmentType === BY_PHONE_ID;
    }
    get isOnVideoFlow() {
        return this.appointmentType === IN_BRANCH_BY_ONLINE_VIDEO;
    }
    get isOnSiteFlow() {
        return this.appointmentType === ON_SITE_ID;
    }
    get isOnSiteInBranchFlow() {
        return this.appointmentType === IN_BRANCH_BY_ON_SITE;
    }
    get isFaceToFaceFlow() {
        return this.appointmentType === IN_BRANCH_PUBLIC_ID;
    }
    get isVideoconferenceFlow() {
        return this.appointmentType === IN_BRANCH_VIDEO_ID;
    }
    get isBranchPrivateVideoFlow() {
        return this.appointmentType === IN_BRANCH_PRIVATE_VIDEO_ID;
    }
    get isBranchByPhonePublicFlow() {
        return this.appointmentType === IN_BRANCH_BY_PHONE_PUBLIC_ID;
    }
    get isBranchByPhonePrivateFlow() {
        return this.appointmentType === IN_BRANCH_BY_PHONE_PRIVATE_ID;
    }
    get isBranchByVideoPublicFlow() {
        return this.appointmentType === IN_BRANCH_BY_VIDEO_PUBLIC_ID;
    }
    get isBranchByVideoPrivateFlow() {
        return this.appointmentType === IN_BRANCH_BY_VIDEO_PRIVATE_ID;
    }
    get InServicePointFlow() {
        return this.appointmentType === IN_SERVICE_POINT;
    }
    get InServicePointByPhoneFlow() {
        return this.appointmentType === IN_SERVICE_POINT_BY_PHONE;
    }
    get isInServicePointFlow() {
        return this.InServicePointFlow || this.InServicePointByPhoneFlow;
    }
};
__decorate([
    AppointmentStore.State('appointmentType')
], AppointmentMixin.prototype, "appointmentType", void 0);
AppointmentMixin = __decorate([
    Component
], AppointmentMixin);
export default AppointmentMixin;
;
